module.exports = __webpack_public_path__ + "img/le-blanc.974563ef.png";